import LocalStorageCache from 'lyjs/es/cache/LocalStorageCache'

import {APP_NAME} from 'services/constants'

export default new LocalStorageCache(`${APP_NAME}/histories`)
